const HowDoYouLikeToExplore = Object.freeze({
  LET_THE_DAY_UNFOLD: 'let_the_day_unfold',
  SHOW_ME_THE_LOCAL_SIDE: 'show_me_the_local_side',
  SEE_THE_MUST_SEES: 'see_the_must_sees',
  EXPLORE_WITH_A_GUIDE: 'explore_with_a_guide',
} as const);

export type HowDoYouLikeToExplore =
  (typeof HowDoYouLikeToExplore)[keyof typeof HowDoYouLikeToExplore];

export const allHowDoYouLikeToExplore: [
  HowDoYouLikeToExplore,
  ...HowDoYouLikeToExplore[],
] = Object.values(HowDoYouLikeToExplore) as [
  HowDoYouLikeToExplore,
  ...HowDoYouLikeToExplore[],
];

export default HowDoYouLikeToExplore;
